import { render, staticRenderFns } from "./vSelectIdentity.vue?vue&type=template&id=45dca6a1&scoped=true&"
import script from "./vSelectIdentity.vue?vue&type=script&lang=js&"
export * from "./vSelectIdentity.vue?vue&type=script&lang=js&"
import style0 from "./vSelectIdentity.vue?vue&type=style&index=0&id=45dca6a1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dca6a1",
  null
  
)

export default component.exports